import React, { useState } from "react";
import { Button } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";

export default function ResendInvite({ id, title }) {
  const [loading, setLoading] = useState(false);

  if (!id) return null;

  function onClick() {
    setLoading(true);

    axios
      .post(`/surveys/${id}/resend-invite/`)
      .then(() => {
        toast.success(`Email sent!`);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <Button variant="light" size="xs" onClick={onClick} loading={loading}>
      Resend
    </Button>
  );
}
